import React from 'react'
import { C } from '../theme'

// Centered modal overlay on the parchment system. Click the backdrop (or ✕) to close.
export default function Modal({ title, onClose, children, width = 460 }) {
  return (
    <div onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 60, background: 'rgba(40,30,12,0.42)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '48px 16px' }}>
      <div role="dialog" aria-modal="true" aria-label={title} onClick={e => e.stopPropagation()}
        style={{ width, maxWidth: '100%', background: C.paper, border: `1px solid ${C.ruleStrong}`, borderRadius: 8, boxShadow: `0 12px 40px ${C.shadow}`, padding: 18 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
          <h2 style={{ flex: 1, margin: 0, fontFamily: "'Cinzel', serif", fontSize: 18, letterSpacing: 0.5, color: C.ink }}>{title}</h2>
          <button onClick={onClose}
            style={{ padding: '3px 9px', borderRadius: 4, border: `1px solid ${C.rule}`, background: C.paperRaised, color: C.ink, cursor: 'pointer', fontSize: 14 }}>✕</button>
        </div>
        {children}
      </div>
    </div>
  )
}
